import CDKIdEditor from '@/components/deal/cdk-id-editor';
import DealMenu from '@/components/deal/deal-menu/deal-menu';
import MobileDealMenu from '@/components/deal/deal-menu/mobile-deal-menu';
import { useBuildHubSlashInboxUrl } from '@/components/nav/utils/url-builders.ts';
import { Button } from '@/components/ui/button.tsx';
import { PDKNavigateBackIcon } from '@/components/ui/pdk-icons.tsx';
import { useInboxContext } from '@/contexts/inbox-provider.tsx';
import { useIsMobile } from '@/hooks/use-mobile';
import type { Deal } from '@/models/registry';
import { useNavigate } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

const MobileHeader = observer(({ deal }: { deal: Deal }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const inboxUrl = useBuildHubSlashInboxUrl();
  const { isFromMobileInbox } = useInboxContext();

  return (
    <div className="flex flex-row gap-2 items-center justify-between w-full h-full flex-nowrap my-1">
      <div className="flex flex-row gap-2 items-center flex-nowrap">
        {isFromMobileInbox && (
          <Button
            onClick={() => navigate({ to: inboxUrl })}
            variant="ghost"
            size="sm"
            className="p-0"
          >
            <PDKNavigateBackIcon />
          </Button>
        )}
        <div className="px-2  whitespace-nowrap">{deal.short_id ?? ''}</div>
        {isMobile ? <MobileDealMenu deal={deal} /> : <DealMenu deal={deal} />}
      </div>
      <div className="flex flex-row gap-2 items-center flex-nowrap px-2 justify-between w-full">
        <CDKIdEditor deal={deal} />
      </div>
    </div>
  );
});

export default MobileHeader;
